import '../../../Modals/XpektorBootstrapModal.scss';
import { Modal } from 'react-bootstrap';
import { useState } from 'react';
import UserService from '../../../../../Services/UserService';
import {
  XpektorForm,
  FormInput,
  FormDropdown,
  FormButton,
} from '../../../../../Components/XpektorForms/XpektorForms';
import Regex from '../../../../../Components/Utilities/Regex';

/* eslint-disable react/prop-types */
export default function CreateUserModal({ handleClose, onCreated }) {
  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userRole, setUserRole] = useState(1);
  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');

  const requiredText = 'Fältet kan inte vara tomt';
  const invalidEmailText = 'Ej giltig adress';
  const [creating, setCreating] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newNameError = '';
    let newEmailError = '';

    if (userName.length === 0) newNameError = requiredText;

    if (userEmail.length === 0) {
      newEmailError = requiredText;
    } else if (!Regex.testEmail(userEmail)) {
      newEmailError = invalidEmailText;
    }

    if (nameError.length > 0 || emailError.length > 0) {
      setNameError(newNameError);
      setEmailError(newEmailError);
      return;
    }

    const currentUser = UserService.getCurrentUser();
    const newUser = {
      customerId: currentUser.customerId,
      email: userEmail,
      name: userName,
      role: Number(userRole),
    };

    setCreating(true);
    await UserService.CreateUser(newUser)
      .then(async (response) => {
        await onCreated(response.data);
        handleClose();
      })
      .catch((error) => {
        if (error.response.status === 400) {
          setEmailError('Det finns redan en användare med den email-adressen');
        } else {
          setEmailError('Något gick fel, kunde inte skapa användare');
        }
      })
      .finally(() => {
        setCreating(false);
      });
  };

  return (
    <Modal
      show
      onHide={handleClose}
      backdrop="static"
      centered
      keyboard={false}
      className="border-0 xpektor-bootstrap-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Skapa ny användare</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Användaren kommer att få ett mejl med en länk för att aktivera sitt
          konto.
        </p>
        <XpektorForm onSubmit={handleSubmit}>
          <FormInput
            label="För och efternamn"
            value={userName}
            onChange={(e) => {
              if (e.target.value.length > 0) setNameError('');
              else setNameError(requiredText);

              setUserName(e.target.value);
            }}
            infoText={nameError}
            maxLength={100}
          />
          <FormInput
            label="Email"
            value={userEmail}
            onChange={(e) => {
              if (e.target.value.length === 0) {
                setEmailError(requiredText);
              } else if (!Regex.testEmail(e.target.value)) {
                setEmailError(invalidEmailText);
              } else {
                setEmailError('');
              }

              setUserEmail(e.target.value);
            }}
            infoText={emailError}
            maxLength={100}
          />
          <FormDropdown
            label="Användarroll"
            defaultValue={1}
            onChange={(e) => setUserRole(e.target.value)}
          >
            <option value={0}>Användare</option>
            <option value={1}>Admin</option>
          </FormDropdown>
          <FormButton
            text={creating ? 'Skapar...' : 'Skapa användare'}
            disabled={creating}
          />
        </XpektorForm>
      </Modal.Body>
    </Modal>
  );
}
